import { Controller } from "@hotwired/stimulus"

// Menu latéral rétractable sur mobile.
export default class extends Controller {
  static targets = ["panel", "scrim"]

  toggle() { this.set(!this.panelTarget.classList.contains("is-open")) }
  close() { this.set(false) }

  set(open) {
    this.panelTarget.classList.toggle("is-open", open)
    this.scrimTarget.classList.toggle("is-open", open)
  }
}
